import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/cn";

const badge = cva("inline-flex items-center rounded-sm px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset", {
  variants: {
    status: {
      success: "bg-success-bg text-success-fg ring-success-border",
      warning: "bg-warning-bg text-warning-fg ring-warning-border",
      error: "bg-error-bg text-error-fg ring-error-border",
      neutral: "bg-neutral-100 text-neutral-600 ring-neutral-200",
      info: "bg-info-bg text-info-fg ring-info-border",
    },
  },
  defaultVariants: { status: "neutral" },
});

type BadgeProps = VariantProps<typeof badge> & {
  children: React.ReactNode;
  className?: string;
};

export function Badge({ status, children, className = "" }: BadgeProps) {
  return <span className={cn(badge({ status }), className)}>{children}</span>;
}
